export default __webpack_public_path__ + "static/media/photo3.738587b4.jpg";